import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
  postQueryBodyWithCreator,
} from "../../../utils/reduxHelper";

export const sourcingCartReduxAPI = createApi({
  reducerPath: "sourcingCartReduxAPI",
  baseQuery: baseQueryWithArgs,

  tagTypes: ["addSourcingCartAction", "ManualCatalog"],

  endpoints: (builder) => ({
    //GET Queries
    getCartProducts: builder.query({
      query: (params) => {
        const brandSourcingBrandId = params?.brandSourcingBrandId;
        return getQueryStringWithCreator(
          `s/getCartProducts?brandSourcingBrandId=${brandSourcingBrandId}`
        );
      },
      providesTags: ["getCartProducts"],
    }),
    getOrderDetails: builder.query({
      query: (params) => {
        const orderId = params?.orderId || 0;
        return getQueryStringWithCreator(
          `s/getOrderDetails?orderId=${orderId}`
        );
      },
      providesTags: ["getOrderDetails"],
    }),
    getServiceabilityInfo: builder.query({
      query: (params) => {
        const addressId = params?.addressId;
        const variantIds = params?.variantIds;
        return getQueryStringWithCreator(
          `s/getServiceabilityInfo?address_id=${addressId}&variant_ids=${variantIds}`
        );
      },
      transformResponse: (res) => res?.data || {},
      providesTags: ["getServiceabilityInfo"],
    }),
    // POST Queries
    postCartAction: builder.mutation({
      query: (body) => ({
        url: "s/addSourcingCartAction",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["getCartProducts"],
    }),
    postPlaceOrderRequest: builder.mutation({
      query: (body) => ({
        url: "s/placeOrderRequest",
        method: "POST",
        body: postQueryBodyWithCreator(body),
      }),
      invalidatesTags: ["getCartProducts", "ManualCatalog"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCartProductsQuery,
  useGetOrderDetailsQuery,
  useLazyGetCartProductsQuery,
  useLazyGetServiceabilityInfoQuery,
  usePostCartActionMutation,
  usePostPlaceOrderRequestMutation,
} = sourcingCartReduxAPI;
